const luggage_lost = `Asunto: Queja por pérdida de equipaje
Estimado servicio de atención al cliente de Finnair:
Le escribo para informarle que perdí mi equipaje durante mi reciente vuelo con Finnair.
Mi equipaje no ha llegado conmigo a destino, y esto me ha causado muchas molestias.
Agradecería su ayuda urgente para localizar mi equipaje y garantizar su pronta entrega.
El contenido del equipaje es importante para mí y estoy ansioso por recuperarlo lo antes posible.
Le solicito que me mantenga informado sobre cualquier actualización sobre el estado de mi equipaje y me proporcione un cronograma para su entrega.
Confío en que Finnair tomará las medidas necesarias para resolver este asunto de forma rápida y eficaz.
Gracias por su pronta atención a este problema.
Sinceramente, `;

export default luggage_lost;



















